import axios from "axios";
const jsonConfig = require("../../Config.json");

const sendEmailResponse = async (message) => {
  let allResponse = {}
  try {
    const emailResponse = await axios.post(
      jsonConfig.apiUrl + "ctbulkemailservice",
      message,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        }
      }
    );

    allResponse = emailResponse;

    return Promise.resolve(allResponse)
  }
  catch (error) {
    console.log("error", error);
    return Promise.reject(error);
  }
}

export default sendEmailResponse;